<template>
  <div class="upload-ctn">
    <div v-show="!loading" class="w_100_per dis_flex ali_it_cen flex_wrap">
      <div
        v-for="(item, index) in fileList"
        :key="`${index}-${item.url}`"
        class="upload-preview-img"
        @click="handleClickPreview(item)"
      >
        <img
          :src="isImage(item.url) ? item.url : '/images/file.png'"
          style="object-fit: cover"
        />
        <div v-if="item.name" class="file-name">{{ item.name }}</div>
        <van-icon
          v-if="!disabled"
          name="clear"
          class="icon-delete"
          @click.stop="handleDel(index, item)"
        />
      </div>

      <van-uploader
        v-show="!disabled"
        ref="preview"
        v-model="fileList"
        :max-count="maxCount"
        :max-size="maxSize"
        :multiple="multiple"
        :accept="isDefaultAccept ? acceptDefault : accept"
        :disabled="disabled || loading"
        :preview-image="false"
        :after-read="handleUploadImg"
      >
      </van-uploader>
    </div>
    <van-loading v-show="loading">正在为您上传中，请耐心等待</van-loading>
  </div>
</template>

<script>
import { uploadFile } from "@/api/upload";
import { ImagePreview, Toast } from "vant";
import Compressor from "compressorjs";
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxCount: {
      type: Number,
      default: () => 9
    },
    maxSize: {
      type: Number,
      default: () => 50 * 1024 * 1024
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    accept: {
      type: String,
      default: () => "image/*"
    },
    isDefaultAccept: {
      type: Boolean,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    processFileNameUrlAuto: {
      // 是否自动按fileName fileUrl处理value
      type: Boolean,
      default: () => true
    },
    // 预览前校验
    // 如果不满足previewVali，则不允许用户进行跳转预览
    // 场景举例：pc端浏览器返回，会触发页面重载。导致预览视频文件时返回表单清空。而手机端不会
    previewVali: {
      type: String,
      defualt: () => "" // mobile pc
    }
  },
  data() {
    return {
      loading: false,
      fileList: [] // 文件上传
    };
  },
  created() {},
  computed: {
    acceptDefault() {
      return this.isMobile() ? "image/*,video/*" : "*";
    }
  },
  watch: {
    value(val) {
      this.fileList = this.processFileNameUrlAutoFn(val ? val : []);
    }
  },
  mounted() {
    this.fileList = this.processFileNameUrlAutoFn(this.value);
  },
  methods: {
    // 校验是手机端还是pc端
    checkDevice() {
      const userAgent = navigator.userAgent;

      // 检查设备是否支持触摸
      const hasTouchScreen =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;

      // 获取视口宽度
      const screenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      if (
        /Android|webOS|iPhone|iPad|Mobile|iPod|BlackBerry|IEMobile|Mozilla|Opera Mini/i.test(
          userAgent
        ) &&
        hasTouchScreen && // 定义桌面设备的可能特征：不支持触摸且屏幕宽度较大
        screenWidth < 800
      ) {
        return "mobile";
      } else {
        return "pc";
      }
    },
    // 根据是否开启自动处理，处理传入的数据
    processFileNameUrlAutoFn(arr = []) {
      if (this.processFileNameUrlAuto) {
        return arr.map((item) => ({
          ...item,
          url: item.fileUrl,
          name: item.fileName
        }));
      }
      return arr;
    },
    // 根据是否开启自动处理，处理出去的数据
    processToFileNameUrlAutoFn(arr = []) {
      if (this.processFileNameUrlAuto) {
        return arr.map((item) => ({
          ...item,
          fileUrl: item.url,
          fileName: item.name
        }));
      }
      return arr;
    },
    isMobile() {
      let userAgentInfo = navigator.userAgent;
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      let getArr = Agents.filter((i) => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    },
    isVideo(url) {
      return /(mp4|mov|mwv|flv|avi)$/i.test(url);
    },
    isImage(url) {
      return /(jpg|png|jpeg)$/i.test(url);
    },
    handleDel(index, item) {
      this.fileList.splice(index, 1);
      this.$emit("input", this.processToFileNameUrlAutoFn(this.fileList));
      this.$emit("del", index, item);
    },
    handleBeforeRead(file) {
      const that = this;
      const _file = file;
      return new Promise((resolve, reject) => {
        if (that.isImage(_file.name) && _file.size > 8 * 1024 * 1024) {
          new Compressor(_file, {
            quality: 0.8, // 压缩质量
            success(result) {
              // 处理压缩后的图片文件
              const newFile = new File([result], _file.name, {
                type: "mimeType"
              });

              resolve(newFile);
            },
            error(err) {
              // 处理错误
              Toast("图片压缩失败");
              console.log(err);
              reject(false);
            }
          });
        } else {
          resolve(file);
        }
      });
    },
    async handleUploadImg(file) {
      try {
        console.log("file", file);
        if (file == false) return;
        this.loading = true;

        let compressFileArr = [];
        if (Array.isArray(file)) {
          // 多文件
          for (let item of file) {
            const _file = await this.handleBeforeRead(item.file);
            const name = item.file.name;
            compressFileArr.push({ file: _file, name: name });
          }
        } else {
          // 单文件
          const _file = await this.handleBeforeRead(file.file);
          const name = file.file.name;
          compressFileArr.push({ file: _file, name: name });
        }
        // 计算出需要保留的原数据长度
        let originUrlsLen =
          this.fileList.length - (Array.isArray(file) ? file.length : 1);
        originUrlsLen = originUrlsLen >= 0 ? originUrlsLen : 0;

        console.log("originUrlsLen", originUrlsLen);
        const originUrls = this.fileList.slice(0, originUrlsLen);
        let newFileList = [];
        for (let upItem of compressFileArr) {
          const resp = await uploadFile(upItem.file);
          newFileList.push({ name: upItem.name, url: resp.ossAccessUrl });
        }
        this.fileList = [...originUrls, ...newFileList];
        console.log("  this.fileList.", this.fileList);
        this.$emit("input", this.processToFileNameUrlAutoFn(this.fileList));
        this.$emit("upload", this.processToFileNameUrlAutoFn(this.fileList));
      } catch (e) {
        Toast("上传失败");
        this.fileList.pop();
      } finally {
        this.loading = false;
      }
    },
    handleClickPreview(file) {
      if (this.loading) return;
      const that = this;
      console.log("查看file", file);

      if (!this.isImage(file.url)) {
        if (this.previewVali && this.previewVali != this.checkDevice()) {
          Toast("该设备端暂不支持预览");
          return;
        } else {
          window.location.href = file.url;
        }
      } else {
        const previewImgs = this.fileList.filter((item) =>
          that.isImage(item.url)
        );
        const _imgsArr = previewImgs.map((item) => item.url);
        const index = previewImgs.findIndex((item) => item.url == file.url);
        ImagePreview({ images: _imgsArr, startPosition: index });
      }
    },
    isImageFile(file) {
      if (!file || !file.type) {
        return false;
      }
      return file.type.indexOf("image/") === 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-preview-img {
  width: calc(25vw - 6px);
  height: calc(25vw - 6px);
  flex: 0 0 calc(25vw - 6px);

  display: inline-block;
  margin: 0 24px 24px 0;
  &:nth-child(3n) {
    margin-right: 0px;
  }
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .file-name {
    position: absolute;
    bottom: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    width: 100%;
    text-align: center;

    overflow: hidden;
    font-size: 16px;
    line-height: 32px;
    height: 32px;
    z-index: 10;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .icon-delete {
    position: absolute;
    top: -16px;
    right: -16px;
    z-index: 10;
    color: red;
  }
}
/deep/.van-uploader__upload {
  width: calc(25vw - 6px);
  height: calc(25vw - 6px);
  flex: 0 0 calc(25vw - 6px);
  margin-bottom: 24px;
}
</style>
